import React, { useCallback, useMemo } from 'react'
import { DurationInput, Field } from 'view/components/inputs'
import { Selectbox } from 'view/components/options'
import { Severity, ValidationType } from 'model'
import { Locale, Translation } from 'locale'
import { NegotiationFieldNames } from 'view/routes/requests/LiveNegotiationsGrid/LiveGridColumnNames'

interface OTWSelectboxProps {
  value: number | null | undefined
  className?: string
  readOnly?: boolean
  disabled?: boolean
  remainingRFQTimeMins?: number
  onChange?: () => void
  onUpdate: (value: number | null | undefined) => void
  dataTestId?: string
  withPortal?: boolean
}

export const OTWSelectbox = React.forwardRef((props: OTWSelectboxProps, ref: React.Ref<Selectbox>) => {
  const { value, className, readOnly, disabled, remainingRFQTimeMins, onUpdate, onChange, dataTestId, withPortal } = props

  const getOptionText = useCallback((duration: number) => {
    if (duration === 0) {
      return Locale.translate(Translation.SC_LAST_LOOK)
    } else {
      return Locale.translate(Translation.SC_DURATION_MINUTES, { duration })
    }
  }, [])

  const getOptionDisabled = useCallback((duration: number) => !!remainingRFQTimeMins && duration > remainingRFQTimeMins, [
    remainingRFQTimeMins
  ])

  const validationIssues = useMemo(
    () =>
      value && remainingRFQTimeMins && value > remainingRFQTimeMins
        ? [
            {
              errorMessage: Locale.translate(Translation.SC_INVALID_OTW),
              fieldName: NegotiationFieldNames.OTW_DURATION,
              severity: Severity.ERROR,
              type: ValidationType.INVALID_VALUE
            }
          ]
        : [],
    [value, remainingRFQTimeMins]
  )

  return (
    <Selectbox
      dataTestId={dataTestId}
      ref={ref}
      className={className}
      optionKeys={[0, 5, 10, 15, 30, 60]}
      getOptionText={getOptionText}
      getOptionDisabled={getOptionDisabled}
      nullItemText={Locale.translate(Translation.SC_AS_RFQ)}
      value={value}
      readOnly={readOnly}
      disabled={disabled}
      validationIssues={validationIssues}
      canClear={true}
      onUpdate={onUpdate as any}
      withPortal={withPortal}>
      {value ? (
        <DurationInput dataTestId={'OTWSelectbox-DurationInput-OTWDurationTime'} value={value} onUpdate={onUpdate} onChange={onChange} />
      ) : null}
    </Selectbox>
  )
})

export const OTWSelectboxField = Field(OTWSelectbox)
